import React from 'react';

import { Button } from '@progress/kendo-react-buttons';
import configData from "../appconfig/config.json";
import { FormInput, FormInputnolbl } from '../core/customComponents';
import { Form, Field, FormElement } from '@progress/kendo-react-form';
import { FormCheckbox, FormReviewLabel, FormMaskedTextBox } from '../core/customComponents';
import { termsValidator, CreditAbleValidator, cardValidator1, cardValidator } from '../core/validationRules';
import FormContainer from './FormContainer';
import { requiredValidator } from '../core/validationRules';

let cmpnt = FormReviewLabel;
let creditAbleNumber;

class Home extends React.Component {
    constructor(props) {
        super(props);


        this.state = {
            creditAbleNumber: '',
        }
    }

    updateInputValue = async (event) => {
        //console.log(event.target.value)
        await this.setState({ creditAbleNumber: event.target.value });

    }

    handleSubmit = (event) => {
        localStorage.setItem("RefCA", this.state.creditAbleNumber);
        this.props.history.push('loancalc');
    }

    render() {
        return (
            <div className="container-fluid">

                <div className='outerdivsubheader'>
                    <div className='row'>
                        <div className='col-12'>
                            <h2 className='welcome mb-5' style={{ "marginTop": "2em" }}>{configData.APP_NAME}</h2>
                        </div>
                    </div>
                    <div className=' DynamicFields' style={{ "marginTop": "1em" }} >


                        {/* <hr className="panelLine"> </hr>*/}

                        <div className="panel-collapse collapse in">

                            <div className="panel-body">
                                <div className="row around-xs inputPair">

                                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <legend className='mb-0' >{configData.APP_NAMEHDR}</legend>

                                        <div>
                                            <br></br>
                                            <b>
                                                Please key in your 16-digit Credit Card Account Number.
                                            </b>
                                            {/* <p style={{ color: "blue" }}> You may wish to refer to your CreditAble statement, chequebook or Online banking account for your account number.</p> */}




                                            <Form

                                                onSubmit={this.handleSubmit}
                                                render={(formRenderProps) => (
                                                    <FormElement >

                                                        <Field
                                                            key={'CreditAbleNumber'}
                                                            id={'CreditAbleNumber'}
                                                            name={'CreditAbleNumber'}
                                                            onChange={this.updateInputValue}
                                                            component={FormInputnolbl}
                                                            pattern="[0-9]+" maxLength="16"
                                                            placeholder={'16 digit Credit Card Account Number'}
                                                            hint={'Your Credit Card Account Number'}

                                                            validator={cardValidator1}
                                                        />


                                                        <span className={'k-form-separator'} />



                                                        <div className="text-right fontstylelato" style={{ marginTop: "4rem" }}>
                                                            <Button className="btnMaybank"
                                                                primary={true}
                                                                type={'submit'}
                                                                disabled={!formRenderProps.allowSubmit}>{configData.ON_NEXT}</Button>
                                                        </div>

                                                    </FormElement>

                                                )} />













                                        </div>



                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}



export default Home;